import { getFormSchema } from './form.schema';
import type { FormFields, InFlightCalculation } from './form.types';

export const isSameCalculation = (left: InFlightCalculation, right: InFlightCalculation): boolean =>
    left.sku === right.sku &&
    left.numberOfPets === right.numberOfPets &&
    left.totalCupsPerDay === right.totalCupsPerDay;

export const toCalculationRequest = (values: FormFields, sku?: string): InFlightCalculation | null => {
    if (!sku) return null;

    const parsed = getFormSchema().safeParse(values);
    if (!parsed.success) return null;

    return {
        sku,
        numberOfPets: Number(parsed.data.numberOfPets),
        totalCupsPerDay: Number(parsed.data.totalCupsPerDay),
    };
};

export const toCalculationRequestFromVariables = (variables: {
    id: string;
    numberOfPets: number;
    totalCupsPerDay: number;
}): InFlightCalculation => ({
    sku: variables.id,
    numberOfPets: variables.numberOfPets,
    totalCupsPerDay: variables.totalCupsPerDay,
});
